import React from 'react';
import { useSelector } from 'react-redux';
import config from "config"

import appHistory from 'components/common/appHistory';
export function roleBasedRoute(Component) {

    const RoleBasedRouteComponent = (props) => {
        const user = useSelector(state => state.myAccountReducer.user)
        const tree = useSelector(state => state.overviewReducer.customerOverview)
        let devicemanagementPage = window.location.href.split('#')[1].match(/^\/devicemanagement\//ig);
        let isDeviceManPage = false;
        if (devicemanagementPage) {
            '/devicemanagement/' === devicemanagementPage[0] && (isDeviceManPage = true)
        }
        // role based authenticated route check
        React.useEffect(() => {
            // Allow access to DeviceManagementPage only for Company administrator
            // Only Company administrator will receive tree has type "customer"
            if (isDeviceManPage && tree.type !== "customer") {
                appHistory.push({
                    pathname: '/'
                })
            }
            // is local user ?
            if (user.role !== config.roles[0].rolecode) {
                appHistory.push({
                    pathname: '/'
                })
            }

        }, [user, isDeviceManPage, tree.type])

        return (
            <React.Fragment>
                {<Component {...props} />}
            </React.Fragment>
        )
    }
    return RoleBasedRouteComponent;
}



// WEBPACK FOOTER //
// ./src/components/common/roleBasedRoute.jsx